import i18n from 'core/common/i18n'
import { TVariation } from 'core/pages/ProductNew-v2/types'

export const WEIGHT_OPTIONS = [
  {
    label: i18n.t('productNew.logistic.kg'),
    value: 'kg',
  },
  {
    label: i18n.t('productNew.logistic.g'),
    value: 'g',
  },
]

export const DIMENSION_OPTIONS = [
  {
    label: i18n.t('productNew.logistic.m'),
    value: 'm',
  },
  {
    label: i18n.t('productNew.logistic.cm'),
    value: 'cm',
  },
]

export const PACKAGE_OPTIONS = [
  {
    label: i18n.t('productNew.logistic.ownPackaging'),
    value: 'package',
  },
  {
    label: i18n.t('productNew.logistic.standardPackaging'),
    value: 'standard',
  },
]

export type ProductFreightV2Values = {
  package: {
    weight: {
      value: number
    }
    depth: number
    width: number
    height: number
    weightUn: string
    dimensionUn: string
    standard_package?: string
    selectedFreightId?: string
  }
  variations: TVariation[]
}
